import { Pipe, PipeTransform } from '@angular/core';
import { ConvertorService } from '@veritas-shared/services/convertor.service';

@Pipe({
  name: 'jsonMap'
})
export class JsonMapPipe implements PipeTransform {

  constructor(
    private convertorService: ConvertorService
  ){}

  transform(item: any): string {
    return this.convertorService.getJsonToObj(item);
  }

}
